import docCookies from 'doc-cookies';
import {
  BASE_PURCHASE_TO_DATA_LAYER_URL,
  BASE_URL_SANCTUM,
} from '../misc/consts';

export default (id) => ({
  id: id,

  async getXsfrToken() {
    const response = await fetch(BASE_URL_SANCTUM);
    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
  },

  async sendToDataLayer() {
    this.somethingWentWrong = false;
    await this.getXsfrToken();

    fetch(BASE_PURCHASE_TO_DATA_LAYER_URL, {
      body: JSON.stringify({
        id: this.id,
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('Network response was not OK');
        }
        return response.json();
      })
      .then((response) => {
        this.purchaseToDataLayer(response);
      });
  },

  purchaseToDataLayer(data) {
    const dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
      event: 'registrationSubmitted',
      ecommerce: {
        purchase: data,
      },
    });
  },

  init() {
    this.sendToDataLayer();
  },
});
